import React, { useEffect, useState } from "react";
// import PropTypes from 'prop-types';
import { Link, useNavigate } from "react-router-dom";
import AsyncLocalStorage from "@createnextapp/async-local-storage";
import styled from "@emotion/styled";
import {
  AppBar,
  Avatar,
  Badge,
  Box,
  Popover,
  Button,
  Typography,
  IconButton,
  Toolbar,
  Tooltip,
} from "@mui/material";
import Logout from "@mui/icons-material/Logout";
import TutorExamPopup from "./tutorExam_popup";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import { Bell as BellIcon } from "../icons/bell";
import { UserCircle as UserCircleIcon } from "../icons/user-circle";
import { Users as UsersIcon } from "../icons/users";
import HeaderSidebar from "./headerSidebar";
import classes1 from "../Pages/screenWidth.module.css";
import Chip from "@mui/material/Chip";
import Menu from "@mui/material/Menu";
import classes from "./sidebar.module.css";

import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import axios from "axios";
// import "./navbarWidth.css"
import { tooltipClasses } from "@mui/material/Tooltip";
import { styled as muiStyled } from "@mui/material/styles";

const LightTooltip = muiStyled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgb(17, 171, 17)",
    boxShadow: theme.shadows[1],
    fontSize: 15,
  },
}));

const InCompleteToolTip = muiStyled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgb(255, 7, 7)",
    boxShadow: theme.shadows[1],
    fontSize: 15,
    maxWidth: 250,
  },
}));

const DashboardNavbarRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: "white",
  // boxShadow: theme.shadows[3]
}));

const DashboardNavbar = (props) => {
  const history = useNavigate();
  const { onSidebarOpen, ...other } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [showDot, setShowDot] = useState(true);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setShowDot(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const onSidebarOpen = (e) => {
  //   e.preventDefault();
  //   setOpenSidebar(true);
  // };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // for tutor Exam
  // const options = [
  //   "None",
  //   "Atria",
  //   "Callisto",
  //   "Dione",
  //   "Ganymede",
  //   "Hangouts Call",
  //   "Luna",
  //   "Oberon",
  //   "Phobos",
  //   "Pyxis",
  //   "Sedna",
  //   "Titania",
  //   "Triton",
  //   "Umbriel",
  // ];
  // const ITEM_HEIGHT = 48;
  // const [anchorE2, setAnchorE2] = React.useState(null);
  // const openExam = Boolean(anchorE2);
  // const handleClickExam = (event) => {
  //   setAnchorE2(event.currentTarget);
  // };
  // const handleCloseExam = () => {
  //   setAnchorE2(null);
  // };

  const sendDashbord = async () => {
    let tutor1 = JSON.parse(localStorage.getItem("tutor"));
    let tutor_ls = JSON.parse(localStorage.getItem("tutor")).saveTutor;

    let temp_tutorSaveObj = {
      ...tutor_ls,
      tutStatus: "db",
    };
    console.log({ tutor_ls });
    let temp_tutorObj = {
      ...tutor1,
      saveTutor: temp_tutorSaveObj,
    };
    let tutor_stringified = JSON.stringify(temp_tutorObj);
    console.log({ temp_tutorObj });
    localStorage.setItem("tutor", tutor_stringified);
    const setTutStatus = await axios.post(
      `https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutorWeb/setTutStatus/${tutor_ls.tutor_id}`,
      { tutStatus: "db" }
    );
    if (setTutStatus.data) {
      history("/tutor_dashboard",{replace: true});
      window.location.reload();
    }
  };

  const visitedNoti = async () => {
    try {
      let payload = {
        tutor_id: props.tutorId,
      };
      await axios.post(
        "https://musiclancerapigcp-dev.el.r.appspot.com/v1/api/tutor/vistedNotification",
        payload
      );
      props.setReadNoti(!props.readNoti);
      handleClose();
    } catch (err) {
      console.log(err);
    }
  };

  const clickHandlerLog = () => {
    localStorage.removeItem("tutor");
    window.location.reload();
  };

  return (
    <>
      <DashboardNavbarRoot
        // sx={{

        //   ['@media (min-width:991.5)']: {
        //   left: {
        //     lg: "265px",
        //   },
        //   width: {
        //     lg: "calc(100% - 265px)",
        //   }}
        // }}
        // class="css-1cmoch9-MuiPaper-root-MuiAppBar-root"
        class={classes1.navbarWidth}
        style={{
          width:
            JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutStatus !==
              "db" && "100%",
          left:
            JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutStatus !==
              "db" && "0px",
        }}
        // class={classes1.navbarWidth  }

        // {...other}
      >
        <Toolbar
          disableGutters
          sx={{
            minHeight: 64,
            left: 0,
            px: 2,
          }}
        >
          {/* <IconButton
            onClick={onSidebarOpen}
            sx={{
              display: {
                xs: "inline-flex",
                lg: "none",
              },
            }}
          >
            <MenuIcon fontSize="small" />
           
          </IconButton> */}

          {JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutStatus ==
            "db" && <HeaderSidebar />}

          {/* <Tooltip title="Search">
            <IconButton sx={{ ml: 1 }}>
              <SearchIcon fontSize="small" />
            </IconButton>
          </Tooltip> */}

          {JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutStatus ==
            "exl" && (
            <>
              <Box sx={{ flexGrow: 1 }} />

              <Chip
                label={`Hi, ${props?.name?.split(" ")[0]}`}
                variant="outlined"
                style={{ marginRight: "5px" }}
              />
              <TutorExamPopup />
            </>
          )}

          {(JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutStatus ==
            "db" ||
            JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutStatus ==
              "ex") && (
            <>
              <Box sx={{ flexGrow: 1 }} />
              {props?.saveTutor?.Bank.acc_no !== undefined &&
                props?.saveTutor?.Bank.acc_no !== null && (
                  <Chip
                    label={`Dashboard`}
                    variant="outlined"
                    onClick={sendDashbord}
                    style={{ marginRight: "5px" }}
                  />
                )}
              <Chip
                label={`Hi, ${props?.name?.split(" ")[0]}`}
                variant="outlined"
                style={{ marginRight: "5px" }}
              />
              <TutorExamPopup />
            </>
          )}
          {/* <Tooltip title="Test Given">
            <IconButton sx={{ ml: 1 }}
             aria-label="more"
             id="long-button"
             aria-controls={openExam ? "long-menu1" : undefined}
             aria-expanded={openExam ? "true" : undefined}
             aria-haspopup="true"
             onClick={handleClickExam}
            >
              <span class="fas fa-book-reader"  />
            </IconButton>
          </Tooltip> */}

          {/* <Tooltip title="Contacts">
            <IconButton sx={{ ml: 1 }}>
              <UsersIcon fontSize="small" />
            </IconButton>
          </Tooltip> */}
          <Tooltip title="">
            <IconButton sx={{ ml: 1 }}>
              <Badge color="primary">
                <BellIcon
                  fontSize="small"
                  aria-describedby={id}
                  onClick={handleClick}
                />
                {/* notification  */}
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                >
                  <Typography sx={{ p: 2 }}>
                    {props?.noti > 0 ? (
                      <Link
                        to="/tutor_dashboard/session_requests"
                        className={classes["nav-link"]}
                      >
                        <div
                          style={{ color: "#337ddd", cursor: "pointer" }}
                          onClick={visitedNoti}
                        >{`${props?.noti} new session available`}</div>
                      </Link>
                    ) : (
                      <div
                        style={{ cursor: "default" }}
                      >{`No new session available`}</div>
                    )}
                  </Typography>
                </Popover>
              </Badge>
              {showDot && props?.noti > 0 && (
                <Badge
                  badgeContent={4}
                  color="primary"
                  variant="dot"
                  style={{ paddingBottom: "15px" }}
                />
              )}
            </IconButton>
          </Tooltip>
          {JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutStatus ==
            "db" ||
          JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutStatus ==
            "exl" ? (
            <>
              {props.profilePercent === 100 ? (
                <LightTooltip
                  title="Your profile is complete"
                  style={{ cursor: "pointer", backgroundColor: "white" }}
                >
                  <Avatar
                    className={classes["complete-profile"]}
                    sx={{
                      height: 40,
                      width: 40,
                      ml: 1,
                    }}
                    // src="/static/images/avatars/avatar_1.png"
                    src={props?.profilePic}
                  >
                    <UserCircleIcon fontSize="small" />
                  </Avatar>
                </LightTooltip>
              ) : (
                <InCompleteToolTip
                  title={`Your profile is  ${
                    props.profilePercent
                      ? `${props.profilePercent}% complete`
                      : "incomplete"
                  }. Please complete it`}
                  style={{ cursor: "pointer", backgroundColor: "white" }}
                >
                  <Avatar
                    className={classes["incomplete-profile"]}
                    sx={{
                      height: 45,
                      width: 45,
                      ml: 1,
                    }}
                    // src="/static/images/avatars/avatar_1.png"
                    src={props?.profilePic}
                  >
                    <UserCircleIcon fontSize="small" />
                  </Avatar>
                </InCompleteToolTip>
              )}
            </>
          ) : (
            // <i class="fa-solid fa-power-off"></i>
            <div onClick={clickHandlerLog}>
              <Link to="/" style={{ color: "black" }}>
                <MenuItem>
                  {/* <ListItemIcon> */}
                  <Button>
                    <Logout fontSize="small" style={{ color: "#3f9afd" }} />
                    <span style={{ marginLeft: "3px" }}> Logout</span>
                  </Button>
                  {/* </ListItemIcon> */}
                  {/* Logout  */}
                  {/* <span class="fa-solid fa-power-off"></span> */}
                </MenuItem>
              </Link>
            </div>
          )}
        </Toolbar>
      </DashboardNavbarRoot>
    </>
  );
};

// DashboardNavbar.propTypes = {
//   onSidebarOpen: PropTypes.func
// };

export default DashboardNavbar;
